import { render, staticRenderFns } from "./SelectMultiPaymentTerm.vue?vue&type=template&id=8a67de74&scoped=true"
import script from "./SelectMultiPaymentTerm.vue?vue&type=script&lang=js"
export * from "./SelectMultiPaymentTerm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a67de74",
  null
  
)

export default component.exports